interface SubscriptionPlan {
  features: string[];
  productId: string;
}

export interface PlanType {
  monthly: SubscriptionPlan;
  yearly?: SubscriptionPlan;
}

export interface SubscriptionCategory {
  test?: PlanType;
  testPremium?: PlanType;
  standard?: PlanType;
  premium: PlanType;
  description: string;
}

interface SubscriptionPlans {
  contractor: SubscriptionCategory;
  jobseeker: SubscriptionCategory;
  employer: SubscriptionCategory;
  marina: SubscriptionCategory;
}

export type PlanKey = "test" | "testPremium" | "standard" | "premium";

export const subscriptionPlans: SubscriptionPlans = {
  contractor: {
    description: "Contractors can list their business and services on Seago",
    //   test: {
    //     monthly: {
    //       features: [
    //         "Direct Messaging",
    //         "Reviews",
    //         "Business listing in 3 categories",
    //         "Analytics",
    //         "Geolocalization services",
    //       ],
    //     productId: "price_1Pg83FP1nQyugPWfvtStW02z",
    //   },
    // },
    standard: {
      monthly: {
        features: [
          "Direct Messaging",
          "Reviews",
          "Business listing in 3 categories",
          "Analytics",
          "Geolocalization services",
        ],
        productId: "price_1PfvzIP1nQyugPWfHDoE9UNJ",
      },
      yearly: {
        features: [
          "Direct Messaging",
          "Reviews",
          "Business listing in 3 categories",
          "Analytics",
          "Geolocalization services",
        ],
        productId: "price_1Pg7JtP1nQyugPWfdVuXappx",
      },
    },
    premium: {
      monthly: {
        features: [
          "Direct Messaging",
          "Reviews",
          "Business listing in 5 categories",
          "Analytics",
          "Geolocalization services",
          "Seago selected banner",
        ],
        productId: "price_1Pg2TvP1nQyugPWfMfL3eJnw",
      },
      yearly: {
        features: [
          "Direct Messaging",
          "Reviews",
          "Business listing in 5 categories",
          "Analytics",
          "Geolocalization services",
          "Seago selected banner",
        ],
        productId: "price_1Pg7JHP1nQyugPWfE1CfWwe2",
      },
    },
  },
  jobseeker: {
    description: "Jobseekers can list their skills and services on Seago",
    premium: {
      monthly: {
        features: [
          "Direct messaging",
          "Reviews",
          "Listing in up to 3 crew positions",
          "Analytics",
          "Geolocalization services",
          "Contacts buttons enabled",
        ],
        productId: "price_1PfvuwP1nQyugPWfsZwIfa94",
      },
      yearly: {
        features: [
          "Direct messaging",
          "Reviews",
          "Listing in up to 3 crew positions",
          "Analytics",
          "Geolocalization services",
          "Contacts buttons enabled",
        ],
        productId: "price_1Pg7P7P1nQyugPWftOkix536",
      },
    },
  },
  employer: {
    description: "Employers can list their job offers on Seago",
    premium: {
      monthly: {
        features: [
          "Direct messaging",
          "Reviews",
          "Listing in up to 3 crew positions",
          "Analytics",
          "Geolocalization services",
          "Contacts buttons enabled",
        ],
        productId: "price_1PfvxzP1nQyugPWfVxJxXrCw",
      },
      yearly: {
        features: [
          "Direct messaging",
          "Reviews",
          "Listing in up to 3 crew positions",
          "Analytics",
          "Geolocalization services",
          "Contacts buttons enabled",
        ],
        productId: "price_1Pg7OZP1nQyugPWfmQYYrRgG",
      },
    },
  },
  marina: {
    description: "Marinas can list their services on Seago",
    premium: {
      monthly: {
        features: [
          "Direct messaging",
          "Reviews",
          "Venue description",
          "Facilities",
          "Photos",
          "Analytics",
          "Geolocation services",
        ],
        productId: "price_1PfvtHP1nQyugPWf70YWE5vj",
      },
      yearly: {
        features: [
          "Direct messaging",
          "Reviews",
          "Venue description",
          "Facilities",
          "Photos",
          "Analytics",
          "Geolocation services",
        ],
        productId: "price_1PfvtHP1nQyugPWfjsnZKUn2",
      },
    },
  },
};
